export enum ScoreRating {
  average = 50,
  good = 60,
  great = 70,
  excellent = 80,
  superb = 90,
  perfect = 100,
}
